import { render, staticRenderFns } from "./PopNextLesson.vue?vue&type=template&id=21b2c461&"
import script from "./PopNextLesson.vue?vue&type=script&lang=js&"
export * from "./PopNextLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports